import {
  View,
  Text,
  ScrollView,
  Image,
  TouchableOpacity,
  Pressable,
} from "react-native";
import React, { useEffect, useState } from "react";
import { getUser } from "../../../../services/ProfileSettings/ProfileSettingService";
import { RootState, dispatch, useSelector } from "../../../../redux/store";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import { LinearGradient } from "expo-linear-gradient";
import profileStyle from "../../styles/profileStyle";
import { useNavigation } from "@react-navigation/native";
import FeedIcons from "../../../../assets/Icons/FeedIcons";
import SettingsIcons from "../../../../assets/Icons/SettingsIcons";
import { setLoggedOut } from "../../../../redux/auth/authSlice";
import AsyncStorage from '@react-native-async-storage/async-storage';

interface UserData {
  firstName: string;
  isVerified: boolean;
  photos?: string[];
  isSubscribed: boolean;
}

export default function UserProfile() {
  const navigation = useNavigation();
  const [userData, setData] = useState<UserData | null>(null);

  async function getUserData() {
    const response = await getUser();
    setData(response?.data);
  }
  let profile = useSelector((state: RootState) => state.profile);
  useEffect(() => {
    const fetchData = async () => {
      try {
        await getUserData();
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [profile]);

  const userProfileList = [
    {
      name: "My bookings",
      key: "MyBookings",
      icon: <SettingsIcons.MyBookingIcon />,
      route: "true",
      navigate: "bookings",
    },
    // {
    //   name: "Help center",
    //   key: "HelpCenter",
    //   icon: <SettingsIcons.HelpIcon />,
    //   navigate: "HelpCenter",
    // },
    {
      name: "Settings",
      key: "SettingMain",
      icon: <SettingsIcons.SettingIcon />,
      navigate: "settings-main",
    },
    {
      name: "Log out",
      key: "Logout",
      icon: <SettingsIcons.LogoutIcon />,
    },
  ];

  console.log()

  return (
    <ScrollView
      style={{
        backgroundColor: "white",
        width: "100%",
        position: "relative",
      }}
    >
      {userData != null && (
        <>
          <View style={profileStyle.topHeadPhotoBox}>
            <View style={profileStyle.topHeadPhotoMain}>
              <Image
                style={profileStyle.topHeadPhoto}
                source={{ uri: userData?.photos?.[0] || "" }}
              />
            </View>

            <View style={profileStyle.topHeadLower}>
              <LinearGradient
                colors={["rgba(253, 251, 249, 0)", "rgba(253, 251, 249, 1)"]}
                style={profileStyle.topHeadLower}
              >
                <View
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginBottom: 20,
                    paddingHorizontal: 20,
                  }}
                >
                  <View style={profileStyle.topHeadNameBox}>
                    <View style={profileStyle.nameMainBox}>
                      <Text
                        style={[
                          profileStyle.MainName,
                          {
                            fontFamily: "InterBold",
                            fontSize: 36,
                            opacity: 0.9,
                            letterSpacing: 0.2,
                          },
                        ]}
                      >
                        {userData?.firstName && userData.firstName.length > 9
                          ? userData.firstName.slice(0, 9) + ".."
                          : userData.firstName}
                      </Text>
                      {userData?.isVerified == false && (
                        <FeedIcons.VerifiedBadge />
                      )}
                      {userData?.isVerified == true && (
                        <FeedIcons.VerifiedBadge />
                      )}
                    </View>
                    {/* <Text style={GlobalStyles.bodyText}>SparkX member</Text> */}
                  </View>

                  <View style={profileStyle.CircleMainBox}>
                    <TouchableOpacity
                      style={profileStyle.penBackgroundCircle}
                      onPress={() =>
                        navigation.navigate("EditProfile" as never)
                      }
                    >
                      <SettingsIcons.EditPenIcon />
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={profileStyle.penBackgroundCircle}
                      onPress={() => {
                        navigation.navigate("settings-main" as never);
                      }}
                    >
                      <SettingsIcons.SettingIcon />
                    </TouchableOpacity>
                  </View>
                </View>
              </LinearGradient>
            </View>
          </View>

          <View style={profileStyle.ticketAndHelpMain}>
            {userProfileList.map((item, index) => {
              return (
                <Pressable
                  onPress={() => {
                    if (item.key === "Logout") {
                        AsyncStorage.removeItem("root");
                      dispatch(setLoggedOut());
                    } else {
                      navigation.navigate(item.navigate as never);
                    }
                  }}
                  key={index}
                  style={profileStyle.ticketBox}
                >
                  <Text
                    style={[
                      profileStyle.ticketText,
                      GlobalStyles.captionText,
                      {
                        fontSize: 16,
                      },
                    ]}
                  >
                    {item.name}
                  </Text>
                  {item.icon}
                </Pressable>
              );
            })}
          </View>
        </>
      )}
    </ScrollView>
  );
}
